function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMonitor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "35px",
    height: "24px",
    viewBox: "0 0 35 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 2,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(60.784314%,60.784314%,60.784314%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 1.000893 1.002604 L 57.999107 1.002604 L 57.999107 33.997396 L 1.000893 33.997396 Z M 1.000893 1.002604 ",
    transform: "matrix(0.59322,0,0,0.6,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(60.784314%,60.784314%,60.784314%)",
      fillOpacity: 1
    },
    d: "M 14.832031 21 L 19.578125 21 L 19.578125 22.800781 L 14.832031 22.800781 Z M 14.832031 21 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(60.784314%,60.784314%,60.784314%)",
      fillOpacity: 1
    },
    d: "M 11.269531 22.800781 L 23.136719 22.800781 L 23.136719 24 L 11.269531 24 Z M 11.269531 22.800781 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMonitor);
export default __webpack_public_path__ + "static/media/monitor.263f857c14b7c772307b4ef7e388d5b6.svg";
export { ForwardRef as ReactComponent };